import { mapGetters } from "vuex";

export default {
  data: () => ({
    content: [],
  }),
  beforeMount() {
    this.$store.commit('pageLoad')
  },
  mounted () {
    this.fetchItem().then(() => {
      this.$store.commit('isPageLoad')
    })
  },
  methods: {
    fetchItem (ssr = false) {
      return this.$store.dispatch('fetchCurrentPage', 
        {page: 'zapoi', ssr: ssr, host: this.getHost}
      )
    },
    edit(code, block) {
      if(this.getUser) {
        this.$store.commit('setEditor', 
          {code: code, block: block, page: 'zapoi' }
        )
      }
    }
  },
  computed: {
    ...mapGetters(['getCurrentPage', 'getUser'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/Zapoi/zapoi.js